export default __webpack_public_path__ + "static/media/a008-7.64945309.svg";